import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/lp/supervivencia")({
  beforeLoad: () => {
    throw redirect({ to: "/lp/test-supervivencia", statusCode: 301 });
  },
});
